// extracted by mini-css-extract-plugin
export var label = "_45-1";
export var reminder = "_45-0";